module.exports = __webpack_public_path__ + "img/mobile_header.53049545.svg";